import SpriteSymbol from "../../../../node_modules/svg-baker-runtime/browser-symbol.js";
import sprite from "../../../../node_modules/svg-sprite-loader/runtime/browser-sprite.build.js";
var symbol = new SpriteSymbol({
  "id": "icon-button_icon-10",
  "use": "icon-button_icon-10-usage",
  "viewBox": "0 0 24 24",
  "content": "<symbol xmlns=\"http://www.w3.org/2000/svg\" viewBox=\"0 0 24 24\" id=\"icon-button_icon-10\"><g stroke=\"currentColor\" fill=\"transparent\" stroke-width=\"1.5\"><path d=\"M5 20.918c2.367 2.367 7.849.722 12.244-3.674C21.64 12.85 23.284 7.367 20.918 5\" /><path stroke-linecap=\"round\" stroke-linejoin=\"round\" d=\"M5.043 21L2 17.957l4.192-4.193 3.683 3.683 7.562-7.563-3.682-3.682L17.957 2 21 5.043\" /></g></symbol>"
});
var result = sprite.add(symbol);
export default symbol